module.exports = __webpack_public_path__ + "9382350f38b16aa1b35a93104c42e50c.png";